import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilderTypeSafe, FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import {
  EOtpremniceClient,
  ISyncUlazneRacuneCommand,
  SyncUlazneRacuneCommand,
  TipDokumentaOtpremnica
} from '@kodit/core/data-api';
import { Subscription } from 'rxjs';
import { DynamicDialogRef } from '@kodit/core/shared-ui';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { AlertService, SharedService } from '@kodit/core/services';

@Component({
  selector: 'kodit-sinhronizacija-eotpremnice-form',
  templateUrl: './sinhronizacija-eotpremnice-form.component.html',
  styleUrls: ['./sinhronizacija-eotpremnice-form.component.scss'],
})
export class SinhronizacijaEotpremniceFormComponent
  implements OnInit, OnDestroy {
  form: FormGroup;
  /** Subs */
  private _subs = new Subscription();

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _fb: FormBuilderTypeSafe,
    private _sharedService: SharedService,
    private _alertService: AlertService,
    private _client: EOtpremniceClient
  ) {}

  ngOnInit(): void {
    this._loadForm();

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this._save();
      })
    );
  }

  private _loadForm() {

    this.form = this._fb.group({
      datum:  new FormControl(new Date()),

    });
  }

  private _save() {
    //everything is ok , let's sync it
    this._sharedService.displayLoadingScreen(
      true,
      'Sinhronizacija sa SEF-om...'
    );
    this._subs.add(
      this._client
        .syncSef(this.form.value.datum)
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          this._alertService.addSuccessMsg(res.data);
          this._dialogRef.close(true);
          if(res.messages[0].length > 0){
            this._alertService.addWarnMsg(res.messages[0]);
          }
        })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
